import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/itinerary-item-template/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/itinerary-item-template/${query}`);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/itinerary-item-template/`, data);
    } else {
      return API.apiClient.put(`/itinerary-item-template/${id}`, data);
    }
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/itinerary-item-template/search${query}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  async delete(id) {
    return API.apiClient.delete(`/itinerary-item-template/${id}`);
  }
};
